import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'
import { gsap, ScrollTrigger } from 'gsap/all'
import pageScroll from '../utilities/page-scroll'

// Register plugin
gsap.registerPlugin(ScrollTrigger)

let scrollValue = 0
let carouselActive = 0

var carousel = {
  get stopScroll () {
    return parseInt(document.body.getAttribute('data-lock-scroll'))
  },

  set stopScroll (value) {
    document.body.setAttribute('data-lock-scroll', +value)
  }
}

let swiper = new Swiper('.swiper', {
  spaceBetween: 0,
  mousewheel: true,
  speed: 500,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
})

if (!swiper.length) {
  if (swiper.$el !== undefined) {
    swiper = [swiper]
  } else {
    swiper = false
  }
}
if (swiper !== false) {
  for (const key in swiper) {
    const swiperObj = swiper[key]
    swiperObj.mousewheel.disable()

    swiperObj.on('toEdge', function () {
      if (carouselActive) {
        setTimeout(function () {
          swiperObj.mousewheel.disable()
          pageScroll.enable()
          carouselActive = 0
        }, 700)
      }
    })

    swiperObj.on('reachBeginning', function () {
      if (carouselActive) {
        pageScroll.disableDown()
        carousel.stopScroll = false
      }
    })

    swiperObj.on('reachEnd', function () {
      if (carouselActive) {
        carousel.stopScroll = false
      }
    })
    swiperObj.on('progress', function (swp, progress) {
      if (carouselActive) {
        if (progress > 0 && progress < 1) {
          pageScroll.disable()
        } else if (progress) {
          pageScroll.disableUp()
        } else if (!progress) {
          pageScroll.disableDown()
        }
      }
    })
    ScrollTrigger.matchMedia({
      // desktop
      '(min-width: 968px)': function () {
        var st = ScrollTrigger.create({
          trigger: swiperObj.$el,
          start: '50% 50%',
          end: '50% 50%',
          onEnter: function () {
            if (!swiperObj.progress && carousel.stopScroll) {
              scrollValue =
                swiperObj.$el[0].getBoundingClientRect().top + window.scrollY
              swiperObj.mousewheel.enable()
              carouselActive = 1
              pageScroll.disableDown()
            }
          },
          onLeaveBack: function () {
            if (swiperObj.progress && carousel.stopScroll) {
              scrollValue =
                swiperObj.$el[0].getBoundingClientRect().top + window.scrollY
              swiperObj.mousewheel.enable()
              carouselActive = 1
              pageScroll.disableUp()
            }
          }
        })
      },
      // all
      all: function () {}
    })
  }
  window.addEventListener(
    'scroll',
    function () {
      if (carouselActive) {
        window.scrollTo(0, scrollValue)
      }
    },
    false
  )
}

export default swiper
